package org.solyton.solawi.bid.module.bid.data.api

import kotlinx.datetime.LocalDate
import kotlinx.datetime.LocalDateTime
import kotlinx.serialization.Serializable

typealias ApiRoundComments = RoundComments
typealias ApiRoundComment = RoundComment


@Serializable
data class RoundComments(
    val all: List<RoundComment>
)

@Serializable
data class RoundComment(
    val id: String,
    val comment: String,
    val createAt: LocalDateTime,
    val createdBy: String
)

@Serializable
data class CommentOnRound(
    val comment: String,
    val roundId: String
)
